import axios from 'axios';
import { initData } from './interceptors/helpers';
import { performBaseUrlAppenderInterceptor } from './interceptors/PerformBaseUrlAppender.interceptor';

function currentOrganizationHeader(): string {
  const data = initData();
  return data?.organization?.slug || '';
}

const instance = axios.create({
  baseURL: '',
  timeout: 30000,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-CSRF-Token': (document.getElementsByName('csrf-token') as any)?.[0]?.content || 'unknown',
    'Current-Organization-Slug': currentOrganizationHeader(),
  },
});

instance.interceptors.request.use(performBaseUrlAppenderInterceptor);

export default instance;
